import { useConnection } from 'wagmi';

import { DASH } from '@/app/shared/constants/common';

export interface ReferralAnalyticsProps {
  inviteeActiveBoost?: string;
  referrerTotalEarnings?: string;
  invitedUsers?: string;
  activeInvitees?: string;
}

const ReferralAnalytics = ({
  inviteeActiveBoost = DASH,
  referrerTotalEarnings = DASH,
  invitedUsers = DASH,
  activeInvitees = DASH,
}: ReferralAnalyticsProps) => {
  const { isConnected } = useConnection();

  const stats = [
    {
      label: 'Invitee Active Boost',
      value: isConnected ? inviteeActiveBoost : DASH,
    },
    {
      label: 'Referrer Total Earnings',
      value: isConnected ? referrerTotalEarnings : DASH,
    },
    {
      label: 'Invited Users',
      value: isConnected ? invitedUsers : DASH,
    },
    {
      label: 'Active Invitees',
      value: isConnected ? activeInvitees : DASH,
    },
  ];

  return (
    <div className='flex flex-col gap-4'>
      <h2 className='text-base font-medium text-brand-1100'>Analytics and Rewards</h2>

      <div className='grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4'>
        {stats.map((stat) => (
          <div key={stat.label} className='rounded-md bg-elevated-card-2 pt-5 pr-5 pb-3.5 pl-5'>
            <div className='flex flex-col items-start gap-2 font-normal'>
              <p className='text-sm leading-6 text-gray-400'>{stat.label}</p>
              <p className='text-2xl leading-8 text-brand-1100'>{stat.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferralAnalytics;
